import { createFileRoute } from '@tanstack/react-router'
import { portfolioData } from '@/data/portfolio'
import {
  vetnestCaseStudy as study,
  vetnestStructuredData,
} from '@/data/vetnest'
import VetNestCaseStudy from '@/components/preview/VetNestCaseStudy'

export const Route = createFileRoute('/work/vetnest')({
  head: () => ({
    meta: [
      { title: study.title },
      { name: 'description', content: study.description },
      { name: 'robots', content: 'index, follow, max-image-preview:large' },
      { name: 'author', content: portfolioData.personal.name },
      { property: 'og:title', content: study.title },
      { property: 'og:description', content: study.description },
      { property: 'og:type', content: 'article' },
      { property: 'og:site_name', content: portfolioData.personal.name },
      { property: 'og:locale', content: 'en_IN' },
      { property: 'og:url', content: study.url },
      { property: 'og:image', content: study.image },
      { property: 'og:image:width', content: '1440' },
      { property: 'og:image:height', content: '1000' },
      {
        property: 'og:image:alt',
        content:
          'VetNest Demo Clinic veterinary website interface — fictional sample clinic',
      },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: study.title },
      { name: 'twitter:description', content: study.description },
      { name: 'twitter:image', content: study.image },
      {
        name: 'twitter:image:alt',
        content: 'VetNest veterinary website case study interface',
      },
    ],
    links: [{ rel: 'canonical', href: study.url }],
    scripts: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(
          vetnestStructuredData(portfolioData.personal.name),
        ).replace(/</g, '\\u003c'),
      },
    ],
  }),
  component: VetNestCaseStudy,
})
